// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-subscribing-period[data-v-6df44a34]{margin-bottom:20px}.link-to-unsubscribe[data-v-6df44a34]{align-items:center;display:flex;justify-content:center;margin-bottom:20px;margin-top:20px}", ""]);
// Exports
module.exports = exports;
